import { AuthorizedBaseAxios, flatten } from 'core/axios/axios';

export const fetchPersonalDocumentTypes = () =>
  AuthorizedBaseAxios.get<string[]>(`api/personalDocument`).then(flatten);
